var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    width: 42,
    height: 42,
    rx: 15,
    transform: "rotate(90 42 0)",
    fill: "#009999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7071 10.2929C21.3166 9.90237 20.6834 9.90237 20.2929 10.2929L13.9289 16.6569C13.5384 17.0474 13.5384 17.6805 13.9289 18.0711C14.3195 18.4616 14.9526 18.4616 15.3431 18.0711L21 12.4142L26.6569 18.0711C27.0474 18.4616 27.6805 18.4616 28.0711 18.0711C28.4616 17.6805 28.4616 17.0474 28.0711 16.6569L21.7071 10.2929ZM22 31L22 11L20 11L20 31L22 31Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIcon);
export default __webpack_public_path__ + "static/media/sendMessageIcon.a9beef8a2839b04b12c872a87cd06536.svg";
export { ForwardRef as ReactComponent };